import { useQueryPrimaryCategoryConfigDetail } from '@webapp/platform/organization-management/features/get-primary-category-config-overview/models/useQueryPrimaryCategoryConfigDetail'

export const usePrimaryCategoryConfigDetailPage = ({
  primaryCategoryId,
}: {
  primaryCategoryId: number
}) => {
  const { config } = useQueryPrimaryCategoryConfigDetail({
    id: primaryCategoryId,
  })

  return {
    data: {
      config,
    },
  }
}
